 
 @if (transport() && lineHeight() > 0) {
  <div 
    class="transport-list-card__transfer"
    [style.--transport-line-height.px]="lineHeight()" 
  > 
    <div class="transfer__line-content-wrapper">  
      @if(transport().iconName === walkTransferType) {
        <app-point-list-line [lineHeight]="lineHeight()"/>
      } @else {
        <app-line [iconName]="transport().iconName"/>
      }

      <div class="transport-list-card__content">        
        <app-transport-icon [iconName]="transport().iconName" />

        <span class="content__text">
          <app-transport-name [transportName]="transport().name" />
          
          <app-duration [duration]="transport().duration" />
        </span>
      </div>
    </div>
    
    <app-stop-details 
      [transportList]="transportList()"
      [transport]="transport()"
      [pointTitle]="pointTitle()"
      [previousPointTitle]="previousPointTitle()"
    />
  </div>
}